export const DB_USER = "capstone_team";
export const DB_HOST = "178.16.140.57";
export const DB_NAME = "icarevillage_db_backup";
export const DB_PASSWORD = 2024;
export const DB_PORT = 5432;
export const ENDP_PORT = 3000;
// export const API_IP = "http://localhost:3004";
export const GOOGLE_API_KEY = "AIzaSyABT3QIyPBqvUeDu9ZXIPXrWXdK1z7rW10";
// export const STRIPE_KEY =
//   "pk_live_51OeqSFE6E6kJ7qqerxWk7OvV0YtsawAxGhk5sWEWRPyX1hxf5z1IKrTvlPEeZ8MqPsvjDudundBapZGXeiN6IWwP00HHuxc2M1";
export const STRIPE_KEY =
  "pk_test_51OeqSFE6E6kJ7qqeybXGYiSr0CHLOY0RLe1xt3VYHdzsJ7TzMNWes4zNeHt3V2a0Oq4pJvgbWDb0RQtCEbthTPoA00N1JB2XiI";
export const AMITY_KEY = "b0e8e1533fd3f1314e65d81d5b01138d835a85b3e9606d7a";
// export const API_IP = "https://icaresolutions.ca:3004";
export const API_IP = "https://api-dev.icaresolutions.ca";
// export const API_IP = "http://192.168.1.63:3004";
